/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Už máte účet?`
};

const da_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Har du allerede en konto?`
};

const de_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Sie haben bereits ein Konto?`
};

const en_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Already registered?`
};

const es_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Ya tienes una cuenta?`
};

const fr_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Vous avez déjà un compte ?`
};

const hu_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Már van fiókom?`
};

const it_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Hai già un account?`
};

const nl_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Heb je al een account?`
};

const pl_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Masz już konto?`
};

const pt_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Já tem uma conta?`
};

const sv_account_login_title = /** @type {(inputs: {}) => string} */ () => {
	return `Har du redan ett konto?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_login_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_login_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_login_title", locale)
	if (locale === "cs") return cs_account_login_title(inputs)
	if (locale === "da") return da_account_login_title(inputs)
	if (locale === "de") return de_account_login_title(inputs)
	if (locale === "en") return en_account_login_title(inputs)
	if (locale === "es") return es_account_login_title(inputs)
	if (locale === "fr") return fr_account_login_title(inputs)
	if (locale === "hu") return hu_account_login_title(inputs)
	if (locale === "it") return it_account_login_title(inputs)
	if (locale === "nl") return nl_account_login_title(inputs)
	if (locale === "pl") return pl_account_login_title(inputs)
	if (locale === "pt") return pt_account_login_title(inputs)
	return sv_account_login_title(inputs)
};
export { account_login_title as "account.login_title" }